<nb-select
    #select
    [formControl]="formValueControl"
    placeholder="{{ placeholder }}"
    multiple
    [ngxScrollLock]="select.isOpen"
>
    <!-- Search Box -->
    <nb-select-label *ngIf="customSelectLabel">
        {{ selectLabel }}
    </nb-select-label>
    <nb-option (click)="withStopPropagation && $event.stopPropagation()">
        <nb-form-field>
            <input
                nbInput
                fullWidth
                #filterInput
                [formControl]="nameFieldSearchControl"
                placeholder="Search..."
                (click)="$event.stopImmediatePropagation()"
                (keydown)="$event.stopImmediatePropagation()"
            />
            <button nbSuffix nbButton ghost (click)="clearFilter($event)">
                <nb-icon icon="close-outline" pack="eva"></nb-icon>
            </button>
        </nb-form-field>
    </nb-option>
    <!-- Filtered Options -->
    <nb-option *ngFor="let option of filteredOptions | async" [value]="option">
        <div class="d-flex align-items-center justify-content-between w-100">
            <span>{{ option }}</span>
            <span class="label m-0">
                {{ getCount(option) }}
            </span>
        </div>
    </nb-option>
</nb-select>
